import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { Manifesto } from "../components/Manifesto";
import { ProductDemo } from "../components/ProductDemo";
import { EstimatorTeaser } from "../components/EstimatorTeaser";
import { Pricing } from "../components/Pricing";
import { Trust } from "../components/Trust";
import { Faq } from "../components/Faq";
import { Waitlist } from "../components/Waitlist";
import { BlogPreview } from "../components/BlogPreview";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <ProductDemo />
      <EstimatorTeaser />
      <Pricing />
      <Trust />
      <Faq />
      <Waitlist />
      <BlogPreview />
      <Footer />
    </main>
  );
}
